import React from "react"

import ovLine from "../img/overlays/billboard-line.svg"
import ovLineSmall from "../img/overlays/billboard-line-small.svg"
import buttonBg from "../img/bill-button-bg.svg"

import "../style/billboard.css";

function Billboard() {
    return (
        <div className="billborad-container">
            <img src={ovLine} className="ov line" />
            <div className="text-wrapper">
                <div className="header">
                    <b>#VemserHug</b>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" viewBox="0 0 65 59" fill="none">
                        <path d="M59.4607 4.7432C51.8811 -2.98637 43.1042 0.273591 37.6695 3.72104C34.5987 5.66898 30.3448 5.66898 27.274 3.72105C21.8394 0.273632 13.0625 -2.98628 5.48296 4.74321C-12.5097 23.0919 18.3462 58.4493 32.4719 58.4493C46.5976 58.4493 77.4533 23.0919 59.4607 4.7432Z" fill="white"/>
                    </svg>
                </div>
                <span>A HUG Education atua há mais de 30 anos no desenvolvimento da Educação Socioemocional. Nossa metodologia promove a construção de ferramentas para a gestão e regulação das emoções, fortalecendo tomadas de decisão conscientes, relações mais saudáveis e ambientes escolares mais equilibrados. <br /><br />O processo educativo é pensado para além do aspecto acadêmico, criando espaços para o desenvolvimento emocional e relacional que impactam diretamente o ensino-aprendizagem.</span>
            </div>
            <div className="video-wrapper">
                <div className="video-element">
                    <button>
                        <svg height="70" viewBox="0 0 93 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.49147 10.8317C3.53168 2.71133 12.0211 -2.18772 19.571 0.966465C43.9321 11.1672 66.8838 24.4215 87.8893 40.3938C94.399 45.3599 94.399 55.158 87.8893 60.0906C66.8838 76.0629 43.9321 89.3171 19.571 99.5179C12.0211 102.672 3.53168 97.773 2.49147 89.6527C-0.83049 63.4797 -0.83049 36.9711 2.49147 10.7646V10.8317Z" fill="#2C3E50"/>
                        </svg>
                    </button>
                </div>

                <a href="#">
                    <svg width="260" viewBox="0 0 373 65" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                    <path d="M358.832 59.0726C243.794 66.4161 128.46 66.4161 13.4226 59.0726C8.04675 58.7125 2.36301 53.9212 1.41311 48.488C-0.471036 37.6163 -0.471036 26.9639 1.41311 16.0922C2.36301 10.659 8.04675 5.87294 13.4226 5.5076C128.46 -1.83587 243.794 -1.83587 358.832 5.5076C364.207 5.86772 369.891 10.659 370.841 16.0922C372.725 26.9639 372.725 37.6163 370.841 48.488C369.891 53.9212 364.207 58.7072 358.832 59.0726Z" fill="#2C3E50"/>
                    </svg>

                    <span>Conheça a HUG</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19" viewBox="0 0 28 19" fill="none" className="arrow">
                        <path d="M17.1713 17.9845C16.6269 17.4401 16.6269 16.5606 17.1713 16.0161L22.574 10.5855H1.39603C0.628206 10.5855 -1.52588e-05 9.95729 -1.52588e-05 9.18946C-1.52588e-05 8.42164 0.628206 7.79342 1.39603 7.79342H22.574L17.1574 2.37677C16.6129 1.83231 16.6129 0.952801 17.1574 0.408343C17.7018 -0.136114 18.5813 -0.136114 19.1258 0.408343L26.9436 8.21223C27.4881 8.75669 27.4881 9.6362 26.9436 10.1807L19.1398 17.9845C18.5953 18.515 17.7018 18.515 17.1713 17.9845Z" fill="white"/>
                    </svg>
                </a>
            </div>
            <img src={ovLineSmall} className="ov line-small" />
        </div>
    )
}

export default Billboard